// extracted by mini-css-extract-plugin
export default {"typeChooser":"styles_typeChooser__nqxgg"};